import {createContext, useState} from 'react'

const MainContext = createContext()

export default MainContext;

export const MainProvider = ({children}) => {

  let [mainClass, setMainClass] = useState("");
  let [large, setLarge] = useState(true);

  // d-flex align-items-center py-4 bg-body-tertiary

  const setLargeStatus = (value) => {
    setLarge(value)
  }

  const contextData = {
    mainClass: mainClass,
    setMainClass: setMainClass,
    large: large,
    setLargeStatus: setLargeStatus
  }


  return (
    <MainContext.Provider value={contextData}>
      {children}
    </MainContext.Provider>
  )
}